import React from 'react'
import classes from './Selector.module.css'
import Payway from '../mobilePayway'
import store from '../../../redux/index'
import paywayName from '../../MobileSell/elements/paywayName'

const Selector = (props) => {

    const { item, index, branch, handler, side, setCardCountryCode, checked, active } = props

    let state
    if (branch === 'SELL') {
        state = store.getState().mobileSell
    } else if (branch === 'BUY') {
        state = store.getState().mobileBuy
    } else { 
        state = null
    }

    return (
        <div className={classes.currency__item}>
            <label htmlFor={side === 'COUNTRY' ? item.iso : item} className={classes.label__item}>
                <div className={classes.currency__name} style={{ color: checked ? '#864DD9' : !active ? '#999999' :'' }}>
                    {side === 'COUNTRY' ?
                        item.country
                        : paywayName[item]}
                </div>
                <div className={classes.icon__wrapper}>
                    {side === 'COUNTRY' ?
                        item.countryCode :
                        <Payway paywayCode={item} fail={!active} />}
                </div>
            </label>
            <input type={'radio'} value={side === 'COUNTRY' ? item.iso : item} key={index} id={side === 'COUNTRY' ? item.iso : item}
                onChange={async (event) => side === 'COUNTRY' ?
                <>
                    {setCardCountryCode(event.target.value)}
                    {handler && handler()}
                    </>
                 : handler && !state ? await handler(event) : handler(state, event.target.value)}
            />
        </div>

    )
}

export default Selector

